<div class="wire-rule-set">
  <div class="rule-set-header">
    <!-- AND/OR Toggle -->
    @if (isQueryBuilder) {
      <mat-button-toggle-group [(ngModel)]="ruleSet.condition" (ngModelChange)="ruleSetChanged()" class="query-builder-toggle-buttons">
          <mat-button-toggle class="text-toggle" value="and">AND</mat-button-toggle>
          <mat-button-toggle class="text-toggle" value="or">OR</mat-button-toggle>
      </mat-button-toggle-group>
    }

    <div class="rule-set-actions">
      <button #addFilter type="button" mat-button class="text-btn" (click)="addRule()" data-testid="qb-add-filter">
        +Add filter
      </button>
      @if (isQueryBuilder) {
        <button type="button" mat-button class="text-btn" (click)="addRuleSet()" data-testid="qb-add-group">
            +Add group
        </button>
      }
      @if (allowRemoveRuleSet && isQueryBuilder) {
        <button type="button" mat-button class="text-btn"
            (click)="requestRemoveRuleSet()" data-testid="qb-clear-group">
            -Clear group
        </button>
      }
    </div>
  </div>

  @if (ruleSet.rules.length) {
    <ul class="rules-list">
      @for (rule of ruleSet.rules; track rule; let i = $index; let last = $last) {
        <li class="connector" [class.last]="last">
          @if (isRuleSet(rule)) {
            <wire-rule-set [ruleSet]="rule" [fields]="fields" (removeRuleSetRequest)="removeRuleSet(i)"
            (ruleSetChange)="ruleSetChanged($event, i);" [isQueryBuilder]="true" class="ruleset-item"></wire-rule-set>
          }
          @if (isRule(rule)) {
            <wire-rule [rule]="rule" [fields]="fields" (removeRuleRequest)="removeRule(i)" (ruleChanged)="ruleSetChanged()"></wire-rule>
          }
        </li>
      }
    </ul>
  }
</div>
